import * as tslib_1 from "tslib";
import { findInlineComposeViewState, lazyReplyToMessageAndCreateViewState, lazyFindComposePlugins, } from 'owa-mail-compose-store';
import { getSelectedTableView } from 'owa-mail-list-store';
import isReadingPaneBottom from 'owa-mail-reading-pane-store/lib/utils/isReadingPaneBottom';
import { action } from 'satcheljs/lib/legacy';
import { trace } from 'owa-trace';
var QUOTE_CLASS = 'userQuote';
var SMART_REPLY_CLASS = 'smartReply';
export default action('replyWithText')(function replyWithText(itemId, conversationId, selection, feature, smartReplyExtractionId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var elementClass, elementId, elementTextHtml, existingViewState, viewState, replyToMessageAndCreateViewState, findComposePlugins, composePlugins;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    elementClass = getElementClassName(feature);
                    elementId = elementClass + Math.round(Math.random() * 1000000).toString();
                    elementTextHtml = createHtmlForText(feature, elementId, selection);
                    existingViewState = findInlineComposeViewState(conversationId);
                    viewState = null;
                    if (!existingViewState) return [3 /*break*/, 1];
                    // If the compose view state already exists, this means the compose window is open
                    // Since the compose window is already open, just insert quoted content into email
                    viewState = existingViewState;
                    return [3 /*break*/, 4];
                case 1: return [4 /*yield*/, lazyReplyToMessageAndCreateViewState.import()];
                case 2:
                    replyToMessageAndCreateViewState = _a.sent();
                    return [4 /*yield*/, replyToMessageAndCreateViewState(itemId, true /* isReplyAll */, getListViewType() == 1 /* Message */ ||
                            isReadingPaneBottom() /* useFullCompose */, conversationId, elementTextHtml /* body */, [] /* instrumentationContext */, null /* groupId */, null /* fullComposeTarget */, null /* attachmentFiles */, null /* initialComposeLogTraceId */, smartReplyExtractionId)];
                case 3:
                    viewState = _a.sent();
                    _a.label = 4;
                case 4:
                    if (!viewState) return [3 /*break*/, 6];
                    return [4 /*yield*/, lazyFindComposePlugins.tryImportSync()];
                case 5:
                    findComposePlugins = _a.sent();
                    if (findComposePlugins) {
                        composePlugins = findComposePlugins(viewState);
                        if (composePlugins && composePlugins.contentOperationPlugin) {
                            if (existingViewState) {
                                composePlugins.contentOperationPlugin.insertHtmlIntoEditor(elementTextHtml, getEventName(feature));
                            }
                            else {
                                composePlugins.contentOperationPlugin.moveCaretBelowHtmlElement(elementId);
                            }
                        }
                    }
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
});
function getElementClassName(feature) {
    switch (feature) {
        case 0 /* UserHighlighting */:
            return QUOTE_CLASS;
        case 1 /* SmartReply */:
            return SMART_REPLY_CLASS;
        default:
            trace.warn('replyWithText: Unsupported feature inputted');
            return '';
    }
}
function getEventName(feature) {
    switch (feature) {
        case 0 /* UserHighlighting */:
            return 'UserHighlighting';
        case 1 /* SmartReply */:
            return 'SmartReply';
        default:
            trace.warn('replyWithText_getEventName: Unsupported feature inputted');
            return '';
    }
}
function createHtmlForText(feature, elementId, textForMarkup) {
    switch (feature) {
        case 0 /* UserHighlighting */:
            return createQuoteTextHtml(elementId, textForMarkup);
        case 1 /* SmartReply */:
            return createSmartReplyHTML(elementId, textForMarkup);
        default:
            trace.warn('replyWithText_createHtmlForText: Unsupported feature inputted');
            return '';
    }
}
function createQuoteTextHtml(quoteId, quoteText) {
    var quoteElement = document.createElement('div');
    quoteElement.id = quoteId;
    quoteElement.className = QUOTE_CLASS;
    quoteElement.innerText = quoteText;
    quoteElement.style.borderLeft = '3px solid #C8C8C8';
    quoteElement.style.paddingLeft = '10px';
    quoteElement.style.color = '#666666';
    quoteElement.style.fontSize = '17px';
    var elementWrapper = document.createElement('div');
    elementWrapper.appendChild(document.createElement('br'));
    elementWrapper.appendChild(quoteElement);
    elementWrapper.appendChild(document.createElement('br'));
    return elementWrapper.innerHTML;
}
function createSmartReplyHTML(smartReplyId, smartReplyText) {
    var smartReplyElement = document.createElement('span');
    smartReplyElement.id = smartReplyId;
    smartReplyElement.innerText = smartReplyText;
    var elementWrapper = document.createElement('div');
    elementWrapper.appendChild(smartReplyElement);
    return elementWrapper.innerHTML;
}
function getListViewType() {
    var listViewType = null;
    var tableView = getSelectedTableView();
    if (tableView && tableView.tableQuery) {
        listViewType = tableView.tableQuery.listViewType;
    }
    return listViewType;
}
//# sourceMappingURL=replyWithText.js.map